import React, { ReactElement, useState } from 'react';
import '../ReportingAndAnalytics.less';

interface TabOption {
  label: string;
  value: string;
}
interface TabSwitcherProps {
  tabs: TabOption[];
  onChange: (selected: string) => void;
  selected?: string;
}

const DateSwitcher: React.FC<TabSwitcherProps> = ({
  tabs,
  onChange,
  selected,
}: TabSwitcherProps): ReactElement => {
  const [internalActiveTab, setInternalActiveTab] = useState(tabs?.[0].value);

  const isControlled = selected !== undefined;
  const activeTab = isControlled ? selected : internalActiveTab;

  const handleClick = (value: string): void => {
    if (!isControlled) {
      setInternalActiveTab(value);
    }
    onChange(value);
  };

  return (
    <div className="tab-switcher">
      {tabs?.map(
        ({ label, value }: any): ReactElement => (
          <div
            key={value}
            className={`tab-btn ${activeTab === value ? 'active' : ''}`}
            onClick={(): void => handleClick(value)}
          >
            {label}
          </div>
        ),
      )}
    </div>
  );
};

export default DateSwitcher;
